/* eslint-disable react/no-unescaped-entities */
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions'
import React, { useContext } from 'react'

import colorContext from '../../../../Context/colorContext'

export default function Title(): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles(() => ({
    main: {
      width: '100%',
      height: 270,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.accentColorBackground,
      marginTop: 1,
    },
    container: {
      color: colors.textAccentColor,
    },
    iconAcessibility: {
      width: 60,
      height: 60,
      marginBottom: 24,
    },
  }))
  const classes = useStyles()
  return (
    <Box className={classes.main}>
      <Box
        display="flex"
        maxWidth="1052px"
        alignItems="center"
        width="100%"
        justifyContent="center"
        flexDirection="column"
        className={classes.container}
      >
        <EmojiEmotionsIcon className={classes.iconAcessibility} />
        <Typography
          style={{
            textAlign: 'center',
          }}
          className={classes.container}
          variant="h4"
        >
          Pesquisa de satisfação
        </Typography>
      </Box>
    </Box>
  )
}
